import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { faFilePdf, faImage } from '@fortawesome/free-solid-svg-icons';
import { PatientService } from 'src/app/admin/services/patient.service';
interface DialogData {
  patientId: string;
  files: any[];
  albumId: string;
  type: string;
}
@Component({
  selector: 'app-album-dialog',
  templateUrl: './album-dialog.component.html',
  styleUrls: ['./album-dialog.component.scss']
})
export class AlbumDialogComponent implements OnInit {
  faImage = faImage;
  faFilePdf = faFilePdf;
  selectedFile: {type: string, src: string};
  showcase = false;
  loading = false;
  constructor(public dialogRef: MatDialogRef<AlbumDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private patientService: PatientService, private _snackBar: MatSnackBar) { }
  uploadedFile = {name: '', type: '', source: null};
  ngOnInit(): void {
    console.log(this.data);
    if(this.data.type === 'photos'){
      this.patientService.getAlbumById(this.data.albumId).then(res => {
        this.data.files = res.mediaItems;
      });
    }
  }
  close(): void {
    this.dialogRef.close();
  }

  uploadFile(){
    let description = '';
    this.patientService.uploadFile(this.data.albumId, this.uploadedFile, description).then(res => {
      console.log(res)
    });
  }

  uploadPhoto(){
    let description = '';
    this.loading = true;
    this.patientService.uploadPhoto(this.data.albumId, this.uploadedFile, description).then(res => {
      this.openSnackBar(res.newMediaItemResults[0].status.message);
      this.close();
    }).catch(err => err);
  }

getFile(fileId: string, mimeType: string): Promise<string>{
  this.showcase = true;
  this.loading = true;
  document.getElementById('showcaseImage').setAttribute("src", '');
  document.getElementById('showcaseFile').setAttribute("src", '');
  return this.patientService.getPatientFile(fileId, mimeType).then(res => {
    if(mimeType.includes('image')){
      document.getElementById('showcaseImage').setAttribute("src", res);
    }else{
      document.getElementById('showcaseFile').setAttribute("src", res);
    }
    this.selectedFile = {
      type: mimeType.includes('image') ? 'image' : 'file',
      src: res
    }
    this.loading = false;
    return res;
  }).catch(err => console.log(err))

}
  
  async onFileSelected(event): Promise<void>{
    let reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file: File = event.target.files[0];
          reader.onload = () => {
              this.uploadedFile = {
                source: reader.result,
                type: file.type,
                name: file.name
              }
          };
          reader.readAsDataURL(file)
    }
  }

  async onPhotoSelected(event): Promise<void>{
    let reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file: File = event.target.files[0];
      reader.readAsArrayBuffer(file);
      console.log(file);
          reader.onload = (e) => {
              this.uploadedFile = {
                source: reader.result,
                type: file.type,
                name: file.name
              }
          };
          // this.uploadedFile.source = new Int8Array(this.uploadedFile.source as ArrayBuffer);
    }
  }


  openSnackBar(message: string) {
    this._snackBar.open(message, 'OK', {
      duration: 3000
    });
  }
}
